export default __webpack_public_path__ + "static/media/pages.70e1765e.svg";